module.exports = __webpack_public_path__ + "img/stock7.1cdd1e29.png";